var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lote.status === _vm.statusVendido && _vm.getArremate)?_c('status-pagamento-lote',{attrs:{"pagamento":{status: Number(_vm.getArremate.status)}}}):_c('status-lote-selector',{staticClass:"no-select no-wrap text-nowrap",attrs:{"status":_vm.lote.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }